import apiWrapper from '../../../../common/api/api-wrapper';
import {
	MockExecutedList,
	MockScheduleList,
} from '../../../../common/api/mock';

import {
	IJobSchedulerRequest,
	IJobSchedulerSuccessResponse,
	IJobSchedulerErrorResponse,
	IGetEventsRequest,
	IGetEventsResponse,
} from './type-def.js';

const SCHEDULER_SERVICE_URL = process.env.REACT_APP_SCHEDULER_SERVICE_URL;
const CIP_SERVICE_URL = process.env.REACT_APP_CIP_SERVICE_URL;

export const createSchedule = async (data: IJobSchedulerRequest) => {
	const resp = await apiWrapper.post<
		IJobSchedulerSuccessResponse | IJobSchedulerErrorResponse
	>(`${SCHEDULER_SERVICE_URL}/schedule-job`, data);
	return resp;
};

export const getEvents = async (data: IGetEventsRequest) => {
	const resp = await apiWrapper.post<IGetEventsResponse>(
		`${CIP_SERVICE_URL}/events/search?page=0&size=100`,
		data,
	);
	return resp;
};

export const getScheduleDetails = async () =>
	// await apiWrapper.get<object[]>(
	//   `${process.env.REACT_APP_USER_MANAGEMENT_SERVICE_URL}/validateUserCredentials?userId=${data.email}&password=${data.password}`
	// );
	MockScheduleList;

export const getExecutedDetails = async () =>
	// await apiWrapper.get<object[]>(
	//   `${process.env.REACT_APP_USER_MANAGEMENT_SERVICE_URL}/validateUserCredentials?userId=${data.email}&password=${data.password}`
	// );
	MockExecutedList;
